export default __webpack_public_path__ + "static/media/Group-6-Yono-mitc.dbcd8913.png";